'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { TotemWithLocation } from '@/features/totems/presentation/actions/web-totem/get-totem-with-location';
import { totemContextQueryOptions, totemsKeys } from '@/features/totems/presentation/queries/totems.queries';
import { supabase } from '@/shared/infrastructure/supabase/client';

export function useTotemContext(totemId: string) {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery(totemContextQueryOptions(totemId));

  useEffect(() => {
    if (!totemId) return;

    const channel = supabase
      .channel(`totem-version:${totemId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'totems',
          filter: `id=eq.${totemId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: totemsKeys.context(totemId) });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [totemId, queryClient]);

  return {
    totem: data as TotemWithLocation | null | undefined,
    isLoading,
    error,
  };
}
